import { useContext, useEffect } from 'react';
import { generateImpression, IMMEDIATE_FEATURES } from 'utils/experiment';
import { OptimizelyContext } from '@optimizely/react-sdk';
import { OPTIMIZELY_FEATURE_ON, useFeatureVariation, } from 'plugins/optimizely/hooks/use-feature-variation';
export const useFacilityGoogleRedirect = ({ partner, spotId, search }) => {
    const { optimizely } = useContext(OptimizelyContext);
    const facilityRedirectVariation = useFeatureVariation(IMMEDIATE_FEATURES.ACQUISITION_FACILITY_GOOGLE_REDIRECT, { generateImpression: false });
    useEffect(() => {
        generateImpression(optimizely, IMMEDIATE_FEATURES.ACQUISITION_FACILITY_GOOGLE_REDIRECT);
        if (facilityRedirectVariation === OPTIMIZELY_FEATURE_ON) {
            window.location.href = `/parking-spot/${spotId}${search}`;
        }
    }, [partner, facilityRedirectVariation, optimizely, spotId, search]);
};
